/**
 * Échec d'un appel /upload (REST zorni-controller). Porte le statut HTTP réel,
 * le message de l'API et son correlationId (à communiquer au support : il
 * retrouve la requête dans les logs serveur), pour qu'un appelant puisse
 * s'arrêter et informer l'utilisateur au lieu de poursuivre son enchaînement.
 */
export class UploadError extends Error {
  constructor(message, { status, correlationId, cause } = {}) {
    super(message);
    this.name = "UploadError";
    this.status = status ?? null;
    this.correlationId = correlationId ?? null;
    this.originalError = cause;
  }
}
